import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FeaturedWorks() {
  const featured = works.filter((w) => w.hot).slice(0, 6);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <SectionHeading
          eyebrow="HOT MANHWA"
          title="本周热门连载"
          desc="被全网读者追更最多的韩漫代表作，日更无遮拦，点击即看。"
        />
        <Link
          to="/tuijian"
          className="mb-8 md:mb-10 inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {featured.map((w) => (
          <WorkCard key={w.id} work={w} />
        ))}
      </div>
    </section>
  );
}